function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.9403 29.8812L25.1906 41.4588L42.3147 14.665L65 40.3562V0H0V50.0869L15.9403 29.8812ZM22.8505 11.7981C24.072 11.4869 25.3618 11.5858 26.5216 12.0798C27.6815 12.5738 28.6473 13.4354 29.2706 14.5323C29.8939 15.6292 30.1403 16.9007 29.9718 18.1514C29.8034 19.4021 29.2294 20.5628 28.3382 21.4552C27.4469 22.3476 26.2877 22.9223 25.0385 23.0909C23.7894 23.2596 22.5196 23.0129 21.424 22.3888C20.3285 21.7647 19.468 20.7977 18.9747 19.6363C18.4813 18.475 18.3825 17.1836 18.6933 15.9605C18.9335 14.9628 19.4391 14.0489 20.1566 13.316C20.874 12.5831 21.7765 12.0585 22.7679 11.7981H22.8505Z",
  fill: "#DB5C0E"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M42.6726 20.04L25.3833 47.0269L15.8577 35.1185L0 55.3517V64.9997H64.9174V45.2627L42.6726 20.04Z",
  fill: "#DB5C0E"
});

var SvgDropzoneLogo = function SvgDropzoneLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDropzoneLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dropzoneLogo.8f5e3831.svg";
export { ForwardRef as ReactComponent };